module.exports = __webpack_public_path__ + "img/menu-sheying.e316791b.svg";